<template>
  <div class="animated fadeIn">
    <b-row class="py-2">
      <b-card header="Editar Contacto" class="w-100">
        <b-form @submit.prevent="store" autocomplete="off">
          <b-row class="pb-2">
            <b-col sm="12" md="6">
              <b-form-group>
                <label for="name"><strong>Nombre</strong></label>
                <b-input-group>
                  <b-form-input
                    type="text"
                    id="name"
                    placeholder="Nombre"
                    v-model="contact.name"
                    autocomplete="new-name">
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="6">
              <b-form-group>
                <label for="surname"><strong>Apellidos</strong></label>
                <b-input-group>
                  <b-form-input
                    type="text"
                    id="surname"
                    placeholder="Apellidos"
                    v-model="contact.surname"
                    autocomplete="new-surname">
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="12">
              <b-form-group>
                <label for="email"><strong>Email *</strong></label>
                <b-input-group>
                  <b-form-input
                    type="email"
                    id="email"
                    placeholder="Email"
                    autocomplete="off"
                    v-model="contact.email"
                    required>
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <location-contact-form
            :initial-community="contact.address.name"
            :initial-province="contact.address.province"
            :initial-town="contact.address.town"
            :initial-address="contact.address.address"
            :initial-postal-code="(contact.address.postalCode != undefined && contact.address.postalCode != null) ? parseInt(contact.address.postalCode) : 0 "
            :input-size="'6'"
            @community-change="community => {contact.address.name = community}"
            @province-change="province => {contact.address.province = province}"
            @town-change="town => {contact.address.town = town}"
            @address-change="address => {contact.address.address = address}"
            @postal-code-change="postalCode => {contact.address.postalCode = postalCode}"
            :contact="contact">
          </location-contact-form>
          <b-row>
            <b-col>
              <b-form-group
                label="<strong>Listas de Distribución</strong>"
                label-for="distribution"
                :horizontal="false"
                class="w-100">
                <multiselect
                  name="distribution"
                  v-model="contact.distributions"
                  :options="distributionLists"
                  track-by="uuid"
                  label="name"
                  :multiple="true"
                  :allowEmpty="true"
                  placeholder="Distribución"
                  selectLabel="+"
                  deselectLabel="-">
                  <template slot="label" slot-scope="{ option }">
                    {{ option.name }}
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="<strong>Preferencias dadas de baja</strong>"
                label-for="unsubscribe"
                :horizontal="false"
                class="w-100">
                <multiselect
                  name="unsubscribe"
                  v-model="contact.contactCampaignTypes"
                  :options="contactCampaignTypes"
                  track-by="uuid"
                  label="name"
                  :multiple="true"
                  :allowEmpty="true"
                  placeholder="Tipo"
                  selectLabel="+"
                  deselectLabel="-">
                  <template slot="label" slot-scope="{ option }">
                    {{ option.name }}
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <div class="col float-left">
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                :disabled="!generalValidate()"
                v-if="mixinCheckPermission('CONTACT_EDIT')">
                Guardar
              </button>
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-row>
  </div>
</template>

<script>

    import Multiselect from 'vue-multiselect';
    import {updateContact} from '@/api/contact-api';
    import LocationContactForm from "@/components/location/LocationContactForm.vue";
    import {getDistributions} from "@/api/distribution-list-api";
    import {getCampaignTypes} from "@/api/campaign-type-api";

    export default {
        name: 'editContact',
        components: {
            LocationContactForm,
            Multiselect
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/communications/contacts/list', brand: 'fa fa-arrow-left'},
                ],
                distributionLists: [],
                contactCampaignTypes: [],
                contact: {
                  name: null,
                  surname: null,
                  email: null,
                  address: {
                    name: null,
                    address: null,
                    town: null,
                    postalCode: null,
                    province: null,
                    main: true
                  },
                  distributions: [],
                  contactCampaignTypes: []
                },
                visible: false,
                error: true,
            }
        },
        async created() {
          this.$eventHub.$emit('captureMenu', this.topmenu);
          await this.getContact();
          this.getDistributions();
          this.getCampaignTypes();
        },
        methods: {
            async getContact() {
                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get('contact/' + this.$route.params.uuid);
                    this.$_loadingMixin_hideLoading();
                    if (response.status === 200) {
                      // this.contact = response.data;
                      this.contact = Object.assign(this.contact,response.data);

                      this.contact.contactCampaignTypes = this.contact.contactCampaignTypes
                        .filter(campaignType => campaignType.unsubscribe === true)
                        .map(campaignType => ({
                          uuid: campaignType.campaignType.uuid,
                          name: campaignType.campaignType.name
                        })
                      );
                    }
                } catch (error) {
                    this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    return error;
                }
            },
            async getDistributions() {
                this.$_loadingMixin_showLoading();
                await getDistributions()
                    .then((distributions) => {
                        this.distributionLists = distributions.distributionLists;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getCampaignTypes() {
                this.$_loadingMixin_showLoading();
                try {
                    const campaignTypesResponse = await getCampaignTypes();
                    this.contactCampaignTypes = campaignTypesResponse.campaignTypes.map(campaignType => ({
                        uuid: campaignType.uuid,
                        name: campaignType.name
                    }));
                } catch (error) {
                    console.error('Error fetching campaign types:', error);
                } finally {
                    this.$_loadingMixin_hideLoading();
                }
            },
            store() {
                this.$_loadingMixin_showLoading();

                const distributionUUIDs = this.contact.distributions.map(distribution => distribution.uuid);
                const campaignTypeUUIDs = this.contact.contactCampaignTypes.map(campaignType => campaignType.uuid);
                const payload = {

                  email: this.contact.email,
                  name: this.contact.name,
                  surname: this.contact.surname,
                  distributions: distributionUUIDs,
                  campaignTypes: campaignTypeUUIDs,
                  address: this.contact.address,
                };

                Object.keys(this.contact).forEach(k => (this.contact[k] === "") && delete this.contact[k]);

                updateContact(this.$route.params.uuid, payload)
                    .then((response) => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$router.push({path: '/communications/contacts/list'});
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
            },
            generalValidate() {
                if (!this.contact.email) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
</script>
